import { HttpRequest, HttpResponse } from '../interfaces/http'
import { ErrorCategory } from '../interfaces/error/ErrorCategory.Enum'
import { ErrorExcerpt } from '../interfaces/error/ErrorExcerpt'

const removeSensitiveFromHttpRequest = (httpRequest: HttpRequest): HttpRequest => {
  const headers = (httpRequest.headers as {Authorization: string})
  if (headers?.Authorization) {
    const newHeaders = { ...headers, Authorization: '<hidden (sensitive info)>' }
    return { ...httpRequest, headers: newHeaders }
  }
  return httpRequest
}

export abstract class ApiError extends Error {
  public readonly name: string

  public readonly code: string | number

  public readonly category: ErrorCategory

  private readonly excerptExtra: {[key: string]: unknown} | undefined | {};

  public readonly localTime: Date

  public readonly message: string

  public readonly httpResponse: HttpResponse | null

  public readonly httpRequest: HttpRequest

  public readonly originalError?: Error

  constructor(arg: {
    code: string | number;
    message?: string;
    excerptExtra?: {[key: string]: unknown};
    httpRequest: HttpRequest;
    category: ErrorCategory;
    originalError?: Error;
    httpResponse?: HttpResponse;
  }) {
    const myMessage = arg.message ? arg.message : `Error: ${arg.code.toString()}`
    super(myMessage)
    // Set the prototype explicitly.
    Object.setPrototypeOf(this, ApiError.prototype)
    this.localTime = new Date()
    this.excerptExtra = arg.excerptExtra
    this.name = this.constructor.name
    this.category = arg.category
    this.httpRequest = arg.httpRequest
    this.message = myMessage
    this.code = arg.code
    if (arg.originalError) this.originalError = arg.originalError
    if (arg.httpResponse) {
      this.httpResponse = arg.httpResponse
    } else {
      this.httpResponse = null
    }
  }

  get excerpt(): ErrorExcerpt {
    const base = {
      'error class': this.constructor.name,
      message: this.message,
      code: this.code,
      'server-url': this.httpRequest.url,
    }
    if (this.excerptExtra) {
      return { ...base, ...this.excerptExtra }
    }
    return base
  }

  // Can be overwritten in children classes
  // to include more properties
  public toJSON(): string {
    return JSON.stringify(this.getBaseJSON())
  }

  protected getBaseJSON() {
    return {
      errorClass: `${this.name}/${this.constructor.name}`,
      category: this.category,
      code: this.code,
      message: this.message,
      'time-occurred-utc': this.localTime,
      http: {
        request: removeSensitiveFromHttpRequest(this.httpRequest),
        response: this.httpResponse,
      },
    }
  }
}
